import React from "react";
import './CustomSelect.scss';
import { Dropdown, MultipleDropdown } from "../Dropdown/Dropdown";
import Images from "../Image/Image";
import PropTypes from 'prop-types';
import { getvalue, SetOption, sortData, CheckValue } from "../../../services/CommonFunction";

class CustomSelect extends React.Component {
  constructor(props) {
    super(props);

    // @value => Show value in select
    // @showOptionList => Show / Hide List options
    this.state = {
      value: [],
      showOptionList: false,
      id: '',
      touched: false
    };
  }

  componentDidMount() {
    // Add Event Listner to handle the click that happens outside
    // the Custom Select Container
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({
      value: this.setvalue(this.checkValueType(this.props.value), this.props.optionLists),
      id: this.uniqueID()
    });
    this.handleOptionClick = this.handleOptionClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const value = this.checkValueType(nextProps.value);
    this.setState({
      value: this.setvalue(value, nextProps.optionLists)
    })
  }

  setvalue = (value, optionLists) => {
    let data = [];
    if (value.length) {
      value.forEach(option => {
        const index = optionLists.findIndex(res => getvalue(res) === getvalue(option));
        if (index >= 0) {
          data.push(SetOption(optionLists[index]));
        } else if (this.props.def && !this.props.multiple) {
          if (typeof option === 'string') {
            data.push({
              name: option,
              label: option,
              value: option,
              thumb: undefined,
              icon: undefined,
              original: undefined,
              parent: undefined
            });
          } else {
            data.push(SetOption(option));
          }
        }
      });
    }
    return data;
  }

  checkValueType = (value) => {
    if(Array.isArray(value)) {
      return value;
    } else if(typeof value === 'object')  {
      return [value];
    } else if(typeof value === 'string') {
      return [value];
    }
    return [];
  }

  componentWillUnmount() {
    // Remove the event listner on component unmounting
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  // This method handles the click that happens outside the
  // select text and list area
  handleClickOutside = e => {
    if (
      e.target.getAttribute('meta-id') !== this.state.id ||
      (!e.target.classList.contains("custom-select-container") &&
        !e.target.classList.contains("custom-select-option") &&
        !e.target.classList.contains("listImage") &&
        !e.target.classList.contains("selectText") &&
        !e.target.classList.contains("checkmarks") &&
        !e.target.classList.contains("selected-text"))
    ) {
      this.setState(prevState => {
        return {
          showOptionList: false,
          touched: prevState.showOptionList || prevState.touched ? true : false
        }
      });
    }
  };

  uniqueID = () => {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  // This method handles the display of option list
  handleListDisplay = () => {
    if (this.props.disabled) {
      return
    }
    // this.props.touched(this.props.formKey);
    this.setState(prevState => {
      return {
        showOptionList: !prevState.showOptionList,
        touched: prevState.showOptionList || prevState.touched ? true : false
      };
    });
  };

  newValue = (option, data, status = null) => {
    const value = option.value
    const index = this.props.optionLists.findIndex(res => getvalue(res) === value);
    const newItem = SetOption(this.props.optionLists[index]);
    if (this.props.multiple && data) {
      const ind = data.findIndex(res => res.value === value);
      if (ind >= 0) {
        if (!status || !CheckValue(status)) {
          data.splice(ind, 1);
        }
      } else {
        if (status || !CheckValue(status)) {
          data.push(newItem);
        }
      }
    } else {
      data = [newItem];
    }
    return data;
  }

  checkData = async (option, status) => {
    if (option.value === '') {
      return []
    }
    let data = this.checkValueType(this.state.value);
    if (CheckValue(option.parent) && option.child.length) {
      await option.child.forEach(el => {
        data = this.newValue(el, data, status);
      })
    } else {
      data = await this.newValue(option, data);
    }
    return this.props.optionLists.filter(res => data.some(el => el.value === getvalue(res)));
  }

  // This method handles the setting of name in select text area
  // and list display on selection
  handleOptionClick = async (option, status) => {
    await this.setState({
      showOptionList: this.props.multiple
    });
    if (!Object.keys(option).length) {
      return
    }
    const newValue = await this.checkData(option, status);
    this.props.onClick(this.props.multiple ? newValue : newValue[0]);
    this.setState({ touched: true });
  };

  render() {
    const { compare, optionLists, showImage, hasError, label, multiple, depend, disabled, touch, sort, invalid, errorText } = this.props;
    const { showOptionList, touched, value } = this.state;

    let text = '';
    let newEquipments = [
      // {
      //   value: '',
      //   name: 'Select',
      //   label: 'Select',
      //   thumb: selectIcon('companyPH'),
      //   icon: selectIcon('companyPH'),
      //   original: selectIcon('companyPH'),
      // }
    ];

    optionLists.forEach((option) => {
      if (compare === undefined || !compare.value.some(ele => getvalue(ele) === getvalue(option))) {
        if (CheckValue(option.parent)) {
          const parentIndex = newEquipments.findIndex(res => res.parent === option.parent);
          if (parentIndex >= 0) {
            newEquipments[parentIndex].child.push(SetOption(option));
            newEquipments[parentIndex].child.sort(sortData);
          } else {
            newEquipments.push({
              name: option.parent,
              label: option.parent,
              value: option.parent,
              thumb: undefined,
              icon: undefined,
              original: undefined,
              parent: option.parent,
              child: [SetOption(option)]
            });
          }
        } else {
          newEquipments.push(SetOption(option));
        }
      }
    });
    if (sort) {
      newEquipments.sort(sortData);
    }

    if (value && value.length && optionLists.length) {
      let x = [];
      text = value.map((data, index) => {
        if (value.length === optionLists.length && CheckValue(data.parent)) {
          if (x.findIndex(el => el === data.parent) < 0) {
            x.push(data.parent);
            return (<div className="selectText" meta-id={this.state.id} key={'select-' + index}>
              <span className="option-label">{data.parent}</span>
            </div>)

          }
        } else if (data !== undefined) {
          return (<div className="selectText" meta-id={this.state.id} key={'select-' + index}>
            {showImage && (data.thumb || data.icon) ? <Images class={`image${data.icon ? ' icon' : ''}`} src={data.thumb || data.icon} alt={data.name || data.label} /> : null}
            <span className="option-label">{data.name || data.label || data.title}</span>
          </div>)
        }
        return null;
      });
    }

    const dropdown = multiple ?
      <MultipleDropdown depend={depend} showImage={showImage} id={this.state.id} showOptionList={showOptionList} optionsList={newEquipments} handleOptionClick={this.handleOptionClick} selectedText={value} />
      :
      <Dropdown depend={depend} showImage={showImage} id={this.state.id} showOptionList={showOptionList} optionsList={newEquipments} handleOptionClick={this.handleOptionClick} selectedText={value} />
    return (

      <React.Fragment>
        <div meta-id={this.state.id} className={`custom-select-container${disabled ? " form-disabled" : ""}`}>
          <div meta-id={this.state.id} className={`selected-text${(touch || touched) && invalid ? ' inputError' : ''}${showOptionList ? " active" : ""}`} onClick={this.handleListDisplay}>
            {text || 'Select'}
          </div>
          {!disabled && dropdown}
        </div>
        {(touch || touched) && hasError("required") && <span className="error">{errorText || (label + " is required")}</span>}
        {hasError("incorrect") && <span className="error">{errorText || (label + " is required")}</span>}
      </React.Fragment>
    );
  }
}

export default CustomSelect;

CustomSelect.propTypes = {
  label: PropTypes.string.isRequired,
  keyValue: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  // formKey: PropTypes.string,
  depend: PropTypes.string,
  multiple: PropTypes.bool,
  touch: PropTypes.bool.isRequired,
  showImage: PropTypes.bool,
  def: PropTypes.bool,
  sort: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  optionLists: PropTypes.array.isRequired,
  compare: PropTypes.object,
  hasError: PropTypes.func,
  touched: PropTypes.func,
  onClick: PropTypes.func,
  formValue: PropTypes.array
}

CustomSelect.defaultProps = {
  showImage: false,
  def: false,
  sort: true,
  disabled: false,
  invalid: false,
  multiple: false,
  touch: false,
  optionLists: [],
  compare: { value: [] },
  label: '',
  errorText: null,
  depend: 'no-item',
  keyValue: 'value',
  touched: () => null,
  hasError: () => null
}